var context = require.context('../images/home/quanjing', true, /\.(png|jpe?g|webp)$/i);

function stripExtension(fileName) {
  return fileName.replace(/\.[^.]+$/, '');
}

function sortByName(a, b) {
  return a.name.localeCompare(b.name, undefined, {
    numeric: true,
    sensitivity: 'base'
  });
}

function getSceneSortInfo(sceneKey) {
  var match = sceneKey.match(/^([a-zA-Z]+)(\d+)$/);
  if (!match) {
    return null;
  }
  return {
    prefix: match[1],
    index: parseInt(match[2], 10)
  };
}

function sortSceneKeys(a, b) {
  var infoA = getSceneSortInfo(a);
  var infoB = getSceneSortInfo(b);

  if (infoA && infoB && infoA.prefix === infoB.prefix) {
    if (infoA.index !== infoB.index) {
      return infoA.index - infoB.index;
    }
  }

  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base'
  });
}

function buildOrderedSceneKeys(sceneKeys) {
  var preferredColumns = ['huazhu', 'zhongduan', 'lvyue'];
  var columnMap = {
    huazhu: [],
    zhongduan: [],
    lvyue: []
  };
  var rest = [];

  sceneKeys.forEach(function (sceneKey) {
    var info = getSceneSortInfo(sceneKey);
    if (info && preferredColumns.indexOf(info.prefix) !== -1) {
      columnMap[info.prefix].push(sceneKey);
      return;
    }
    rest.push(sceneKey);
  });

  preferredColumns.forEach(function (prefix) {
    columnMap[prefix].sort(sortSceneKeys);
  });
  rest.sort(sortSceneKeys);

  var ordered = [];
  var maxRows = Math.max(
    columnMap.huazhu.length,
    columnMap.zhongduan.length,
    columnMap.lvyue.length
  );

  for (var i = 0; i < maxRows; i++) {
    preferredColumns.forEach(function (prefix) {
      if (columnMap[prefix][i]) {
        ordered.push(columnMap[prefix][i]);
      }
    });
  }

  return ordered.concat(rest);
}

var sceneMap = {};
var indexCoverMap = {};

context.keys().forEach(function (key) {
  var normalizedPath = key.replace('./', '');
  var parts = normalizedPath.split('/');
  if (parts.length < 2) {
    return;
  }

  var folder = parts[0];
  var fileName = parts[parts.length - 1];
  var srcModule = context(key);
  var src = srcModule.default || srcModule;

  if (folder === 'index') {
    indexCoverMap[stripExtension(fileName)] = src;
    return;
  }

  if (!sceneMap[folder]) {
    sceneMap[folder] = {
      sceneKey: folder,
      items: []
    };
  }

  sceneMap[folder].items.push({
    name: fileName,
    src: src
  });
});

var sceneKeys = Object.keys(sceneMap);
sceneKeys.forEach(function (sceneKey) {
  sceneMap[sceneKey].items.sort(sortByName);
});

var orderedSceneKeys = buildOrderedSceneKeys(sceneKeys);

function getSceneByKey(sceneKey) {
  if (!sceneKey) {
    return null;
  }
  return sceneMap[sceneKey] || null;
}

function getGridCards() {
  return orderedSceneKeys.map(function (sceneKey) {
    var scene = sceneMap[sceneKey];
    var firstItem = scene.items[0] || {};
    var info = getSceneSortInfo(sceneKey);
    var columnIndex = 0;
    if (info && info.prefix === 'huazhu') {
      columnIndex = 1;
    } else if (info && info.prefix === 'zhongduan') {
      columnIndex = 2;
    } else if (info && info.prefix === 'lvyue') {
      columnIndex = 3;
    }
    return {
      sceneKey: sceneKey,
      coverSrc: indexCoverMap[sceneKey] || firstItem.src || '',
      coverName: firstItem.name || sceneKey,
      columnIndex: columnIndex
    };
  });
}

module.exports = {
  scenes: sceneMap,
  sceneOrder: orderedSceneKeys,
  gridCards: getGridCards(),
  getSceneByKey: getSceneByKey
};



/** WEBPACK FOOTER **
 ** ./src/js/panoramaImages.js
 **/